import React from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  CardHeader,
  StyledNavLink,
  UserCard,
  UserCardWrapper,
  UserEmail,
  UserInfo,
  UserItem,
  UserList,
  UserLocation,
  UserName,
  UserStatus,
  ViewAllUsers,
} from "./style";
import { adminDashboardRoute } from "../../../../../../utils/routes/Routes";
import { Avatar, Typography } from "@mui/material";
import RowContainer from "../../../../../common/RowContainer";
import { FormattedMessage } from "react-intl";
import { translateStatusString } from "../../../../../../utils/helpers/translateStatusString";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../../../../../redux/features/language/languageSlice";

const RecentUsers = ({ users }) => {
  const currentLanguage = useSelector(selectLanguage);
  return (
    <UserCardWrapper>
      <UserCard>
        <CardHeader>
          <Typography variant="h3" component="h3">
            <FormattedMessage id="dashboard.recentUsers" />
          </Typography>
          <Typography variant="body2" component="p">
            <FormattedMessage id="dashboard.recentUsers.subtitle" />
          </Typography>
        </CardHeader>
        <UserList>
          {users?.paginated_results?.slice(0, 5).map((user) => (
            <UserItem key={user.id}>
              <RowContainer start align="center">
                <UserInfo>
                  <RowContainer halfGap align="center">
                    <Avatar
                      sx={{
                        backgroundColor: "var(--main-color)",
                        height: "30px",
                        width: "30px",
                      }}
                    ></Avatar>

                    <div>
                      <UserName>
                        {user.first_name} {user.last_name}
                      </UserName>
                      <UserEmail>{user.email}</UserEmail>
                    </div>
                  </RowContainer>
                </UserInfo>
              </RowContainer>
              <UserStatus status={user.status}>
                {translateStatusString(user.status, currentLanguage)}
                <UserLocation>{}</UserLocation>{" "}
              </UserStatus>
            </UserItem>
          ))}
        </UserList>
        <ViewAllUsers>
          <StyledNavLink to={adminDashboardRoute.users}>
            <FormattedMessage id="button.viewAll" />
            <ArrowForwardIosIcon fontSize="small" />
          </StyledNavLink>
        </ViewAllUsers>
      </UserCard>
    </UserCardWrapper>
  );
};

export default RecentUsers;
